import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const Home: React.FC = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  // Slayt verileri
  const slides = [
    {
      title: "Kurye olmak ister misiniz?",
      description: "Siz de kurye ekibimize katılabilir ve kendi işinizin patronu olabilirsiniz.",
      buttonText: "Kurye ol",
      buttonLink: "/kuryeol",
      buttonType: "primary",
      isShareButton: false
    },
    {
      title: "Arkadaşını Getir, Kazancını Katla!",
      description: "Kurye arkadaşını ekibimize davet et; sen de kazan, arkadaşın da kazansın.",
      buttonText: "Davet Et",
      buttonLink: "/kuryeol",
      buttonType: "primary",
      isShareButton: true
    },
    {
      title: "P1* Belgeli Kuryelere Özel Bonus!",
      description: "Eğer P1* belgesine sahipsen, Motopack'e katıldığında özel bonus fırsatını kaçırma. Şimdi ekibimize katıl, hem kazancını artır hem de ayrıcalıkları yakala!",
      buttonText: "Kurye ol",
      buttonLink: "/kuryeol",
      buttonType: "primary",
      isShareButton: false
    }
  ];

  // Otomatik slayt geçişi
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [slides.length]);

  // Paylaşım fonksiyonu
  const handleShare = async () => {
    const shareData = {
      title: 'Motopack - Kurye Ol, Kazancını Katla!',
      text: 'Arkadaşını getir, kazancını katla! Motopack ekibine katılmak için tıkla:',
      url: `${window.location.origin}/kuryeol`
    };

    try {
      if (navigator.share) {
        await navigator.share(shareData);
      } else {
        showShareOptions();
      }
    } catch (error) {
      console.log('Paylaşım iptal edildi veya hata oluştu');
    }
  };

  const showShareOptions = () => {
    const shareUrl = `${window.location.origin}/kuryeol`;
    const shareText = 'Arkadaşını getir, kazancını katla! Motopack ekibine katılmak için tıkla:';

    const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(shareText + ' ' + shareUrl)}`;
    const telegramUrl = `https://t.me/share/url?url=${encodeURIComponent(shareUrl)}&text=${encodeURIComponent(shareText)}`;
    const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`;
    const twitterUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}&url=${encodeURIComponent(shareUrl)}`;

    const shareMenu = `
      <div style="
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0.6);
        backdrop-filter: blur(4px);
        z-index: 9999;
        display: flex;
        align-items: center;
        justify-content: center;
      ">
        <div style="
          background: white;
          padding: 2rem;
          border-radius: 16px;
          max-width: 400px;
          width: 90%;
          text-align: center;
          box-shadow: 0 20px 60px rgba(0,0,0,0.2);
        ">
          <h3 style="margin-bottom: 1.5rem; color: #0066CC; font-weight: 700;">Paylaşım Seçenekleri</h3>
          <div style="display: flex; flex-direction: column; gap: 0.75rem;">
            <a href="${whatsappUrl}" target="_blank" style="
              background: #25D366;
              color: white;
              padding: 0.875rem;
              border-radius: 10px;
              text-decoration: none;
              font-weight: 600;
            ">WhatsApp'ta Paylaş</a>
            <a href="${telegramUrl}" target="_blank" style="
              background: #0088cc;
              color: white;
              padding: 0.875rem;
              border-radius: 10px;
              text-decoration: none;
              font-weight: 600;
            ">Telegram'da Paylaş</a>
            <a href="${facebookUrl}" target="_blank" style="
              background: #1877f2;
              color: white;
              padding: 0.875rem;
              border-radius: 10px;
              text-decoration: none;
              font-weight: 600;
            ">Facebook'ta Paylaş</a>
            <a href="${twitterUrl}" target="_blank" style="
              background: #1da1f2;
              color: white;
              padding: 0.875rem;
              border-radius: 10px;
              text-decoration: none;
              font-weight: 600;
            ">Twitter'da Paylaş</a>
            <button onclick="navigator.clipboard.writeText('${shareText + ' ' + shareUrl}').then(() => alert('Link kopyalandı!'))" style="
              background: #E4405F;
              color: white;
              padding: 0.875rem;
              border-radius: 10px;
              border: none;
              font-weight: 600;
              cursor: pointer;
            ">Linki Kopyala</button>
            <button onclick="document.body.removeChild(this.parentElement.parentElement.parentElement)" style="
              background: #64748b;
              color: white;
              padding: 0.875rem;
              border-radius: 10px;
              border: none;
              font-weight: 600;
              cursor: pointer;
              margin-top: 0.5rem;
            ">Kapat</button>
          </div>
        </div>
      </div>
    `;

    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = shareMenu;
    document.body.appendChild(tempDiv.firstElementChild as HTMLElement);
  };

  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const element = entry.target as HTMLElement;
          element.style.opacity = '1';
          element.style.transform = 'translateY(0)';
        }
      });
    }, observerOptions);

    const animateElements = document.querySelectorAll('.feature-card, .animate-on-scroll');
    animateElements.forEach(el => {
      const element = el as HTMLElement;
      element.style.opacity = '0';
      element.style.transform = 'translateY(24px)';
      element.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
      observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <>
      {/* Hero Section */}
      <section style={{
        background: 'linear-gradient(135deg, #0066CC 0%, #003D82 50%, #0066CC 100%)',
        color: '#fff',
        padding: '4rem 0',
        position: 'relative',
        overflow: 'hidden',
        minHeight: '85vh',
        display: 'flex',
        alignItems: 'center',
      }}>
        {/* Background Pattern */}
        <div style={{
          position: 'absolute',
          inset: 0,
          backgroundImage: `radial-gradient(circle at 2px 2px, rgba(255,255,255,0.05) 1px, transparent 0)`,
          backgroundSize: '32px 32px',
          pointerEvents: 'none',
        }} />

        <div style={{
          maxWidth: 1280,
          margin: '0 auto',
          padding: '0 1.5rem',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          gap: '3rem',
          width: '100%',
          position: 'relative',
          zIndex: 2,
        }}>
          {/* Left: Scooter Image */}
          <div style={{
            flex: '0 0 320px',
            maxWidth: 360,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
            <img
              src="/motopack-scooter.png"
              alt="Motopack Scooter"
              style={{
                maxWidth: '100%',
                width: '120%',
                height: 'auto',
                objectFit: 'contain',
                filter: 'drop-shadow(0 20px 40px rgba(0,0,0,0.3))',
              }}
            />
          </div>

          {/* Right: Slider Content */}
          <div style={{
            flex: '1 1 340px',
            minWidth: 280,
            maxWidth: 560,
          }}>
            {slides.map((slide, index) => (
              <div
                key={index}
                style={{
                  display: currentSlide === index ? 'block' : 'none',
                  animation: currentSlide === index ? 'fadeIn 0.5s ease' : 'none',
                }}
              >
                <h1 style={{
                  fontSize: 'clamp(2rem, 4vw, 3rem)',
                  fontWeight: 700,
                  lineHeight: 1.15,
                  marginBottom: '1rem',
                  letterSpacing: '-0.02em',
                }}>
                  {slide.title}
                </h1>
                <p style={{
                  fontSize: '1.125rem',
                  lineHeight: 1.6,
                  marginBottom: '1.5rem',
                  opacity: 0.9,
                  maxWidth: 480,
                }}>
                  {slide.description}
                </p>
                <div>
                  {slide.isShareButton ? (
                    <button
                      onClick={handleShare}
                      style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: '0.875rem 2rem',
                        background: '#fff',
                        color: '#0066CC',
                        fontWeight: 600,
                        fontSize: '1rem',
                        borderRadius: 10,
                        border: 'none',
                        cursor: 'pointer',
                        transition: 'all 0.2s ease',
                        boxShadow: '0 4px 14px rgba(0,0,0,0.15)',
                      }}
                    >
                      {slide.buttonText}
                    </button>
                  ) : (
                    <Link
                      to={slide.buttonLink}
                      style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: '0.875rem 2rem',
                        background: '#fff',
                        color: '#0066CC',
                        fontWeight: 600,
                        fontSize: '1rem',
                        borderRadius: 10,
                        textDecoration: 'none',
                        transition: 'all 0.2s ease',
                        boxShadow: '0 4px 14px rgba(0,0,0,0.15)',
                      }}
                    >
                      {slide.buttonText}
                    </Link>
                  )}
                </div>
              </div>
            ))}

            {/* Slide Indicators */}
            <div style={{
              display: 'flex',
              gap: '0.5rem',
              marginTop: '2rem',
            }}>
              {slides.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentSlide(index)}
                  style={{
                    width: currentSlide === index ? 24 : 8,
                    height: 8,
                    borderRadius: 4,
                    background: currentSlide === index ? '#fff' : 'rgba(255,255,255,0.4)',
                    border: 'none',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                  }}
                  aria-label={`Slide ${index + 1}`}
                />
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section style={{
        padding: '5rem 0',
        background: '#fff',
      }}>
        <div style={{
          maxWidth: 1280,
          margin: '0 auto',
          padding: '0 1.5rem',
        }}>
          <h2 style={{
            textAlign: 'center',
            fontSize: 'clamp(1.75rem, 3vw, 2.25rem)',
            fontWeight: 700,
            color: '#1e293b',
            marginBottom: '3rem',
            letterSpacing: '-0.02em',
          }}>
            Kurye ihtiyaçlarınız için çözüm sunuyoruz.
          </h2>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(340px, 1fr))',
            gap: '1.5rem',
          }}>
            {[
              {
                icon: '/icon/hizli-teslimat-img.svg',
                title: 'Hızlı Teslimat',
                description: 'Müşteri siparişleriniz, güvenli ve hızlı şekilde tam zamanında teslim edilir. Operasyonel verimlilikle, müşteri memnuniyetinizi artırırız.'
              },
              {
                icon: '/icon/entegre-sistem-img.svg',
                title: 'Entegre Sistem',
                description: 'Yemek ve e-ticaret sipariş platformlarıyla tam entegre çalışır. Siparişleriniz otomatik olarak sisteme düşer, süreçleriniz hızlanır.'
              },
              {
                icon: '/icon/raporlama-img.svg',
                title: 'Raporlama',
                description: 'Aylık teslimat sayısı, en yoğun bölgeler ve performans analizleri gibi detaylı raporlar ile işinizi veriye dayalı yönetmenizi sağlarız.'
              },
              {
                icon: '/icon/motor-kurye-img.svg',
                title: 'Motor Kurye',
                description: 'Küçük ve acil gönderileriniz için en hızlı çözüm. Restoranlar için sıcak yemek teslimatında bir numaralı tercihtir.'
              },
              {
                icon: '/icon/arac-kurye-img.svg',
                title: 'Araç Kurye',
                description: 'Büyük hacimli veya çoklu gönderileriniz için ekonomik ve güvenli teslimat. E-ticaret ve marketler için idealdir, randevulu teslimat seçeneğiyle esneklik sunar.'
              },
              {
                icon: '/icon/sezonluk-kurye-img.svg',
                title: 'E-scooter Kurye',
                description: 'Çevreci ve pratik teslimatlar için e-scooter kurye hizmetimizle fark yaratın.'
              },
            ].map((feature, index) => (
              <div
                key={index}
                className="feature-card"
                style={{
                  background: '#fff',
                  borderRadius: 14,
                  padding: '1.75rem',
                  border: '1px solid #e2e8f0',
                  position: 'relative',
                  overflow: 'hidden',
                  transition: 'all 0.2s ease',
                  cursor: 'pointer',
                  textAlign: 'center',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-4px)';
                  e.currentTarget.style.boxShadow = '0 12px 40px rgba(0,0,0,0.08)';
                  e.currentTarget.style.borderColor = '#0066CC';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = 'none';
                  e.currentTarget.style.borderColor = '#e2e8f0';
                }}
              >
                {/* Top accent line */}
                <div style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  height: 2,
                  background: '#0066CC',
                }} />

                <div style={{
                  width: 48,
                  height: 48,
                  margin: '0 auto 1rem',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}>
                  <img
                    src={feature.icon}
                    alt={feature.title}
                    style={{ width: 44, height: 44 }}
                  />
                </div>
                <h3 style={{
                  fontSize: '1.125rem',
                  fontWeight: 600,
                  color: '#1e293b',
                  marginBottom: '0.625rem',
                }}>
                  {feature.title}
                </h3>
                <p style={{
                  fontSize: '0.9375rem',
                  color: '#64748b',
                  lineHeight: 1.6,
                }}>
                  {feature.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section style={{
        background: '#f0f9ff',
        padding: '4rem 0',
      }}>
        <div style={{
          maxWidth: 1280,
          margin: '0 auto',
          padding: '0 1.5rem',
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '1.5rem',
            flexWrap: 'wrap',
          }}>
            {/* Icon */}
            <div style={{
              width: 48,
              height: 48,
              borderRadius: '50%',
              background: 'rgba(0, 102, 204, 0.1)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
            }}>
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                <path d="M6.62 10.79a15.053 15.053 0 006.59 6.59l2.2-2.2a1 1 0 011.11-.21c1.21.49 2.53.76 3.88.76a1 1 0 011 1V20a1 1 0 01-1 1C10.07 21 3 13.93 3 5a1 1 0 011-1h3.5a1 1 0 011 1c0 1.35.27 2.67.76 3.88a1 1 0 01-.21 1.11l-2.2 2.2z" fill="#0066CC" />
              </svg>
            </div>

            {/* Title */}
            <span style={{
              fontWeight: 700,
              fontSize: 'clamp(1.125rem, 2vw, 1.375rem)',
              color: '#0066CC',
              letterSpacing: '-0.02em',
            }}>
              Şimdi İletişime Geçin, Hızlı Teklif Alın
            </span>

            {/* Button */}
            <button
              onClick={() => window.open('https://wa.me/908505325989', '_blank')}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
                background: '#0066CC',
                borderRadius: 50,
                padding: '0.75rem 1.5rem',
                boxShadow: '0 2px 8px rgba(0, 102, 204, 0.2)',
                border: 'none',
                fontWeight: 600,
                fontSize: '0.9375rem',
                color: '#fff',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 8px 24px rgba(0, 102, 204, 0.3)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 2px 8px rgba(0, 102, 204, 0.2)';
              }}
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <path d="M6.62 10.79a15.053 15.053 0 006.59 6.59l2.2-2.2a1 1 0 011.11-.21c1.21.49 2.53.76 3.88.76a1 1 0 011 1V20a1 1 0 01-1 1C10.07 21 3 13.93 3 5a1 1 0 011-1h3.5a1 1 0 011 1c0 1.35.27 2.67.76 3.88a1 1 0 01-.21 1.11l-2.2 2.2z" fill="#fff" />
              </svg>
              0850 532 59 89
            </button>
          </div>
        </div>
      </section>

      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(16px); }
          to { opacity: 1; transform: translateY(0); }
        }

        @media (max-width: 768px) {
          .feature-card {
            padding: 1.25rem !important;
          }
        }
      `}</style>
    </>
  );
};

export default Home;
